import AppContext from "Context/appContext";
import { useContext, memo } from "react";
import { DISPLAYING_PAGES } from "constants";

const Button = (props) => {
  const { disabled, text, continueButtonWidth, quoteButtonWidth, appointmentButtonWidth, buttonHeight, setWidth, typeA, submit, setServiceArray } = props;
  const { setCurrentState, setProgressState, userSettings } = useContext(AppContext)

  
  const toggleState = ()=> {
    switch(text){
     case 'Continue':
     return DISPLAYING_PAGES.FORM
     case 'Get Quote':
     return DISPLAYING_PAGES.BOOKING
     case 'Book an Appointment':
      return DISPLAYING_PAGES.BOOKING
     default:
     return DISPLAYING_PAGES.PRODUCT
    }
  }

  const handleSubmission = ()=>{
  if(submit !== undefined){
    submit()
  }
  } 

  const handleState = ()=> {
    if(setServiceArray !== undefined){
      setServiceArray()
    }
  }

  return (
    <button onClick={()=> {setCurrentState(toggleState);setProgressState(prevState => prevState === 6 ? prevState: prevState+1);handleSubmission(); handleState()}}
      disabled={disabled}
    // ${ setWidth ? 'rd-quote-w-[48%]' : 'rd-quote-w-full'} 
      style={{
        '--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor
      }}
      className={`
      ${continueButtonWidth ? 'rd-quote-w-[27%]' : quoteButtonWidth ? 'rd-quote-w-[100px]' : appointmentButtonWidth ? 'rd-quote-w-[170px]' : 'rd-quote-mt-2 rd-quote-w-full'}
      ${buttonHeight ? 'rd-quote-h-[32px] rd-quote-py-1' : 'rd-quote-py-2'}
      ${!disabled
        ? typeA 
          ? "rd-quote-border rd-quote-border-gray-300 rd-quote-text-gray-700" 
          : "rd-quote-bg-[var(--button-bg-color)] rd-quote-text-white" 
        : "rd-quote-bg-gray-100 rd-quote-text-gray-300"
      } 
      rd-quote-rounded-md rd-quote-text-sm rd-quote-font-medium`}
    >
      {text}
    </button>
  );
};

export default memo(Button);
